(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('ApplicationFeatureDeleteController',ApplicationFeatureDeleteController);

    ApplicationFeatureDeleteController.$inject = ['$uibModalInstance', 'entity', 'ApplicationFeature'];

    function ApplicationFeatureDeleteController($uibModalInstance, entity, ApplicationFeature) {
        var vm = this;

        vm.applicationFeature = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            ApplicationFeature.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
